import { IPagy } from 'src/packages/mitsBasics';
export class PaginateHelper {
  /**
   * Returns an initial build of PageInfo
   * @param maxItems per page e.g. 25
   * @param startPage e.g. 2
   */
  getInitialPageInfo(
    amountItems: number,
    maxItems: number = 25,
    startPage: number = 1
  ): IPagy {
    const initPageInfo = {
      count: amountItems,
      items: maxItems,
      page: startPage,
    };
    return this.generatePageInfo(initPageInfo);
  }

  prevPage(pageInfo: IPagy): IPagy {
    return this.generatePageInfo(pageInfo, pageInfo.page - 1);
  }

  nextPage(pageInfo: IPagy): IPagy {
    return this.generatePageInfo(pageInfo, pageInfo.page + 1);
  }

  setPage(pageInfo: IPagy, page: number): IPagy {
    return this.generatePageInfo(pageInfo, page);
  }

  private generatePageInfo(pageInfo: IPagy = {}, newPage?: number) {
    pageInfo.pages = Math.ceil(pageInfo.count / pageInfo.items);
    pageInfo.page =
      newPage >= 1 && newPage <= pageInfo.pages ? newPage : pageInfo.page;
    pageInfo.last = pageInfo.pages;
    pageInfo.in = pageInfo.items % pageInfo.pages;
    if (newPage) {
      pageInfo.next = newPage === pageInfo.pages ? null : newPage + 1;
      pageInfo.prev = newPage === 1 ? null : newPage - 1;
    } else {
      pageInfo.next = pageInfo.page;
      pageInfo.prev = pageInfo.page;
    }
    return pageInfo;
  }
}
